import React from "react"
import { defPath } from '../config/defPath'
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import { useSession } from '../hooks/useState'

function App() {

  const { validateSession } = useSession(state => state)

  const dataLayerLoad = () => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category':  'Content',
      'event_action': 'Content',
      'event_label': 'You ran out of lives', 
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Game',
      'element_text': 'Llegaste al máximo de partidas diarias',
    });
    
  }
  
  React.useEffect(() => {
    validateSession()
    dataLayerLoad()
  }, [])
  
  const handdleClick = () => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'See ranking - You ran out of lives', 
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Game',
      'element_text': 'Ir al ranking',
    });
    window.location.href = "/estadio-aguila/ranking"
    
  }

  return (
    <>
      <div className="limitAttempts">    
        <NewHeader />
        <Modal />            
        <picture className="">
            <source className="" media="(min-width: 1024px)" srcSet={`${defPath}/assets/images/internNotice/bkLimit.jpeg`}/>
            <img className="limitAttempts--bk" src={`${defPath}/assets/images/instructions/bkLimitMob.jpeg`} alt="" />
        </picture>
        <div className="limitAttempts__content">
          <h2 className="limitAttempts__content--title">¡A las duchas…!</h2>
          <h1 className="limitAttempts__content--subtitle">Vuelve a intentarlo mañana</h1>
          <a className="limitAttempts__content--btn" href="/estadio-aguila/ranking" onClick={handdleClick} >Ir al ranking</a>
        </div>

        
      </div>
    </>    
  )
}
export default App